import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiKey, ApiProvider, ServiceKind } from '../../services/api-keys.service';

interface DialogData { service?: ServiceKind; credential?: ApiKey; previewProviders?: ApiProvider[]; credentialOnly?: boolean; defaultModel?: string; }

/** Material dialog shell; the shared editor owns validation and vault writes. */
@Component({
  selector: 'app-apikey-create-dialog',
  templateUrl: './apikey-create-dialog.component.html',
})
export class ApiKeyCreateDialogComponent {
  constructor(public readonly dialogRef: MatDialogRef<ApiKeyCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogData | null) {
    this.dialogRef.disableClose = true;
  }
}
